import React from 'react';

export const languages = {
  english: 'en',
  espanol: 'es',
  quechua: 'qu',
};

export const LanguageContext = React.createContext(languages.english);
